module.exports = __webpack_public_path__ + "static/media/dubai-3d-building.c9ebceb0.jpg";